import { Component, ViewChild } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { RoleUsers, RoleUsers_Search } from '../model/role-users';
import { NgbAccordionItem } from '@ng-bootstrap/ng-bootstrap';
import { DataService } from 'projects/Shared-Lib/services/data.service';
import { DialogService } from 'projects/Shared-Lib/component/dialog/dialog.service';
import { FilterDataService } from '../services/filter-data.service';
import { SelectListItem } from '../lib/select/select-property';
import { AppService } from '../services/app.service';
import { ReturnClass } from 'projects/Shared-Lib/model/search-result';
import { TableSetting } from 'projects/Shared-Lib/component/table/table-class';

@Component({
  selector: 'app-role-users',
  templateUrl: './role-users.component.html',
  styleUrls: ['./role-users.component.css']
})
export class RoleUsersComponent {
  @ViewChild('acc') acc: NgbAccordionItem; //link to ngAfterViewInit().
  ControllerName: string = 'RoleUsers';

  model: RoleUsers_Search;
  displayedColumns: string[] = ['roleid', 'rolename', 'enabled'];
  // 傳入 DataTable 資料之變數
  TableData: ReturnClass;
  currentRoute: string;
  sampleMenu: any[];

  CanCreate: boolean = true;
  CanDelete: boolean = true;
  CanEdit: boolean = true;

  userPermission: any;
  TableSetting: TableSetting;

  constructor(private dataSer: DataService,
    private DlgService: DialogService, private app: AppService,
    private router: Router, private filterService: FilterDataService) {

    this.model = new RoleUsers_Search();

    this.TableSetting = new TableSetting();
    this.TableSetting.CanUpdate = true;
    this.TableSetting.CanDelete = true;
    this.TableSetting.IdColumnName = 'RoleId';
    this.TableSetting.ItemTitle = (item: RoleUsers) => {
      return `[${item.RoleName}]${item.UserName}`;
    };
    this.TableSetting.CorrespondTableHeard = [
      { columnDef: 'RoleName', header: 'Role Name', cell: (element: RoleUsers) => `${element.RoleName}` },
      { columnDef: 'UserName', header: 'User Name', cell: (element: RoleUsers) => `${element.UserName}` },
      { columnDef: 'UserAccount', header: 'User Account', cell: (element: RoleUsers) => `${element.UserAccount}` },
      { columnDef: 'UpdatedBy', header: 'Update User', cell: (element: RoleUsers) => `${element.UpdatedBy}` },
      { columnDef: 'UpdatedDateTime', header: 'Update Date', cell: (element: RoleUsers) => `${element.UpdatedDateTime.ToDateTimeString()}` }
    ];

    this.userPermission = this.app.currentResource.subscribe(data => {
      this.TableSetting.CanUpdate = false; // data.CanUpdate;
      this.TableSetting.CanDelete = data.CanDelete;
      this.CanCreate = data.CanCreate;
    })

    this.dataSer.getData(this.ControllerName + '/init', null,
      (data) => {
        this.model.ddlRole = new Array<SelectListItem>();
        let i = 1;
        data.Roles.forEach(it => {
          let o: SelectListItem = {
            value: it.RoleId,
            text: it.RoleName,
            index: i++
          };
          this.model.ddlRole.push(o);
        });
        const firstItem: SelectListItem = { value: '0', text: 'All the below', index: 0 };
        this.model.ddlRole.unshift(firstItem);
      });
  }

  ngOnInit() {
    setTimeout(() => this.app.SetLoadingState(true), 0);
    this.currentRoute = this.router.url;
    this.Search();
  }

  ngAfterViewInit() {
    // The ngb-accordion object can only be accessed after the page has initialized : setTimeout(() => this.acc.expandAll(), 0);
  }

  Search() {
    if (this.filterService.HasUsed) {
      let LasttimeSearchInfo = this.filterService.GetSearchInfo();
      if (LasttimeSearchInfo.Filter) {
        this.model.filter = LasttimeSearchInfo.Filter;
      }
    }
    this.filterService.ChangeSearchInfo(this.currentRoute, this.model.filter);

    this.dataSer.getData(this.ControllerName, this.model.filter, (res) => {
      this.TableData = {
        draw: this.model.filter.PageIndex,
        pagingSize: this.model.filter.PageSize,
        recordsTotal: res.TotalCount,
        recordsFiltered: res.TotalCount,
        data: res.DataList
      };
    }, (res) => {
    }, () => {
      setTimeout(() => this.app.SetLoadingState(false), 0);
    });
  }

  // call from child component : data-source-table -> change page size function
  onChangePageInfo(PageInfo: any) {
    this.model.filter.PageSize = PageInfo.PageSize;
    this.model.filter.PageIndex = PageInfo.CurrentPage;

    this.Search();
  }

  onChangeTableInfo(TableInfo: any) {
    this.model.filter.SortBy = TableInfo.SortBy;
    this.model.filter.IsAsc = TableInfo.IsAsc;

    this.Search();
  }


  Delete(DeleteGuid: any) {
    this.app.SetLoadingState(true);
    this.dataSer.DeleteData(`${this.ControllerName}/${DeleteGuid.RoleId}/${DeleteGuid.UserAccount}`, null,
      (res) => {
        console.log(res);
        this.Search();
      },
      (res) => {
        let result = this.DlgService.ErrorInformation(res.Message);
        result.then((ret) => {
        }).catch((error) => {
          console.error(error);
        });
      },
      () => {
        this.app.SetLoadingState(false);
      }
    );
  }
}
